import React from "react";

export default function ViewAssetLayer({ data }) {
  return (
    <div className="card basic-data-table">
      <div className="card-body">

        {/* ==== ASSET DETAILS ==== */}
        <div className="row">
          <div className="col-md-6 row">

            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Title
              </label>
              <p>{data?.title}</p>
            </div>

            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Cost Price
              </label>
              <p>{parseFloat(data?.costPrice).toFixed(2)}</p>
            </div>

            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Quantity
              </label>
              <p>{data?.quantity}</p>
            </div>

            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Added On
              </label>
              <p>{data?.addedOn}</p>
            </div>

          

            <div className="col-md-12 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Description
              </label>
              <div dangerouslySetInnerHTML={{ __html: data?.description }} />
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
